/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import './styles/VersionList.css';
import Utils from '@/common/utils/utils';
import { Button, TextField } from '@material-ui/core';
import FormInput from './element/VersionListElement/AddNewInput/FormInput';
import { FUNCTION_SETTING, BASIC_SETTING, ADVANCED_SETTING } from '@/common/constant/ModuleSettingVersionConstant';
import {
    handleSubmitFormVersion,
    onYesCanCelOrClosePanel,
    onClickNoCanCelOrClosePanel,
    handleCheckSubmitData,
    onClickCancelVersion,
    getVersionDataById,
    callBackReloadPage,
    getProductLicenseKeySetting
} from './handler/VersionListHandler';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import LoadingPanel from '../common/LoadingPanel';
import { useSnackbar } from 'notistack';
import { productManagementAtom } from '@/state/atom/productManagementAtom';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import { updatePanelInitData } from '../multiPanel/panel/handler/PanelHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function VersionList({ onBackEditionPanel, dataProduct, setOpenDropDownVersion, listGptModel = [], ...props }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const [usedFormButtonExpand, setUsedFormButtonExpand] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const [versionName, setVersionName] = useState({
        value: '',
        error: '',
    });
    const [functionSettingValue, setFunctionSettingValue] = useState(FUNCTION_SETTING);
    const [basicSettingValue, setBasicSettingValue] = useState(BASIC_SETTING);
    const [advancedSettingValue, setAdvancedSettingValue] = useState(ADVANCED_SETTING);
    const [lincenseKey, setLincenseKey] = useState({
        value: '',
        error: ''
    });
    const [licenseKeyDefault, setLicenseKeyDefault] = useState('');
    
    const [defaultVersionNameValue, setDefaultVersionNameValue] = useState({
        value: '',
        error: '',
    });
    const [defaultFunctionSettingValue, setDefaultFunctionSettingValue] = useState(FUNCTION_SETTING);
    const [defaultBasicSettingValue, setDefaultBasicSettingValue] = useState(BASIC_SETTING);
    const [defaultAdvancedSettingValue, setDefaultAdvancedSettingValue] = useState(ADVANCED_SETTING);
    const [defaultLincenseKey, setDefaultLincenseKey] = useState({
        value: '',
        error: ''
    });

    const [isSubmit, setIsSubmit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [isEdit, setIsEdit] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);

    const [isClosePanelVersion, setIsClosePanelVersion] = useRecoilState(productManagementAtom);
    const [isShowPopUpCancel, setIsShowPopUpCancel] = useState(false);
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isReloadPage, setIsReloadPage] = useState(false);
    const [isBackToProduct, setIsBackToProduct] = useState(false);
    const [isBackToEdition, setIsBackToEdition] = useState(false);
    const [isChangeLincenseKey, setIsChangeLincenseKey] = useState(false);
    const [isRootSetting, setIsRootSetting] = useState(true);
    const [basicAIPrompt,setBasicAIPrompt] = useState({})
    const [defaultBasicAIPrompt,setDefaultBasicAIPrompt] = useState({})

    const [isChangeSystemPrompt, setIsChangeSystemPrompt] = useState(false);
    const [systemPrompt, setSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [defaultSystemPrompt, setDefaultSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [isChangeInteratorSystemPrompt, setIsChangeInteratorSystemPrompt] = useState(false);
    const [interatorSystemPrompt, setInteratorSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });
    const [defaultInteratorSystemPrompt, setDefaultInteratorSystemPrompt] = useState({
        value: '',
        error: '',
        linkPrompt: ''
    });

    const [chatGPTModel, setChatGPTModel] = useState(Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    const [knn, setKnn] = useState({
        value: Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    });
    const [minScore, setMinScore] = useState({
        value: Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    });

    const [chatGPTModelDefault, setChatGPTModelDefault] = useState(Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    const [knnDefault, setKnnDefault] = useState({
        value: Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    });
    const [minScoreDefault, setMinScoreDefault] = useState({
        value: Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    });

    const [modelSettingList, setModelSettingList] = useState([]);
    const [modelSettingAddList, setModelSettingAddList] = useState([]);
    const [modelSettingListRoot, setModelSettingListRoot] = useState([]);

    // K-Board System Prompt (version-level default, share link -> prompt name chip, max 1 prompt)
    const [kBoardSystemPromptLink, setKBoardSystemPromptLink] = useState('');
    const [defaultKBoardSystemPromptLink, setDefaultKBoardSystemPromptLink] = useState('');
    const [kBoardPromptDetail, setKBoardPromptDetail] = useState({});
    const [errorKBoardSystemPrompt, setErrorKBoardSystemPrompt] = useState('');

    useEffect(() => {
        getProductLicenseKeySetting(
            props?.API,
            dataProduct.productId,
            userDetail.affiliationOrganization,
            setLincenseKey,
            setIsRootSetting,
            setIsLoading,
            setLicenseKeyDefault
        );
    }, []);

    useEffect(() => {
        getVersionDataById(props?.API, 
            dataProduct.versionId, 
            setIsLoading, 
            setVersionName, 
            setFunctionSettingValue, 
            setBasicSettingValue, 
            setAdvancedSettingValue, 
            setDefaultFunctionSettingValue, 
            setDefaultBasicSettingValue, 
            setDefaultAdvancedSettingValue, 
            setDefaultVersionNameValue,
            // setDefaultLincenseKey,     out of scope
            dataProduct.isDuplicateVersion,
            setIsOpenModalReloadPage,
            setIsBackToProduct,
            setIsBackToEdition,
            dataProduct.editionId,
            dataProduct.productId,
            setBasicAIPrompt,
            setDefaultBasicAIPrompt,
            
            setSystemPrompt,
            setDefaultSystemPrompt,
            setChatGPTModel,
            setKnn,
            setMinScore,
            setChatGPTModelDefault,
            setKnnDefault,
            setMinScoreDefault,
            chatGPTModelDefault,
            knnDefault,
            minScoreDefault,

            setInteratorSystemPrompt,
            setDefaultInteratorSystemPrompt,
            
            setModelSettingList,
            setModelSettingAddList,
            setModelSettingListRoot,
            setKBoardSystemPromptLink,
            setDefaultKBoardSystemPromptLink,
            setKBoardPromptDetail,
            setErrorKBoardSystemPrompt
        );
    }, [dataProduct.versionId]);

    useEffect(() => {
        const isValid = handleCheckSubmitData(
            versionName,
            functionSettingValue,
            basicSettingValue,
            advancedSettingValue,
            dataProduct.isEditVersion,
            defaultFunctionSettingValue,
            defaultBasicSettingValue,
            defaultAdvancedSettingValue,
            defaultVersionNameValue,
            setIsEdit,
            lincenseKey,
            isChangeLincenseKey,
            basicAIPrompt,
            defaultBasicAIPrompt,
            knn,
            minScore,
            chatGPTModel,
            knnDefault,
            minScoreDefault,
            chatGPTModelDefault,
            modelSettingList, 
            modelSettingAddList,
            modelSettingListRoot,
            listGptModel,
            kBoardSystemPromptLink,
            defaultKBoardSystemPromptLink
        );
        if (!isValid) {
            setIsSubmit(false);
        } else {
            setIsSubmit(true);
        }
    }, [
        versionName,
        functionSettingValue,
        lincenseKey,
        basicSettingValue,
        advancedSettingValue,
        defaultVersionNameValue,
        defaultAdvancedSettingValue,
        defaultBasicSettingValue,
        defaultFunctionSettingValue,
        defaultLincenseKey,
        basicAIPrompt,
        knn,
        minScore,
        chatGPTModel,
        knnDefault,
        minScoreDefault,
        chatGPTModelDefault,
        modelSettingList, 
        modelSettingAddList,
        modelSettingListRoot,
        kBoardSystemPromptLink,
        defaultKBoardSystemPromptLink
    ]);

    useEffect(() => {
        updatePanelInitData(
            props.panelId,
            props.tabId,
            panelInitData,
            setPanelInitData,
            'isEditedData',
            isEdit
        );
    }, [isEdit]);

    const handleOpenListOptions = id => {
        const addFieldMenuElement = document.getElementById(id);
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'accordionForm accordionForm--show') {
            document.getElementById(id).classList.remove('accordionForm--show');
        } else if (classNameOfElement === 'accordionForm') {
            document.getElementById(id).classList.add('accordionForm--show');
        }
    };

    const handleChangeVersionName = (e) => {
        let inputValue = e.target.value;
        setIsEdit(true);
        //clear error
        setVersionName(prev => ({
            ...prev,
            error: ''
        }));

        //validate length
        if(Utils.isEmptyString(inputValue)) {
            setVersionName(prev => ({
                ...prev,
                error: I18n.get('COMMSG014')
            }));
        }
        
        if(inputValue.length > 200) {
            let msgKeywordMaxLength = I18n.get('COMMSG022').replace('{{maxLength}}', '200');
            setVersionName(prev => ({
                ...prev,
                error: msgKeywordMaxLength
            }));
            setIsSubmit(false);
        }
        //onChange
        setVersionName(prev => ({
            ...prev,
            value: inputValue
        }));
    };

    const handleOnBlur = e => {
        const inputValue = e.target.value;
        if (inputValue.trim() === '') {
            setVersionName(prev => ({
                ...prev,
                error: I18n.get('COMMSG014')
            }));
        }
        if(inputValue.length > 200) {
            let msgKeywordMaxLength = I18n.get('COMMSG022').replace('{{maxLength}}', '200');
            setVersionName(prev => ({
                ...prev,
                error: msgKeywordMaxLength
            }));
        
            return;
        }
    };

    return (
        <form className="version-wrapper">
            <LoadingPanel isLoading={isLoading} />
            <div className="version-header">
                <div className="version-title border-bottom">
                    <p className="header-title">{dataProduct.isEditVersion ? trI18n('TITLE-EDIT-VERSION') : trI18n('CREATE_NEW_VERSION')}</p>
                    <div className="header-actions">
                        <Button
                            className="btn-hg32 btn-light header-actions-btn cancel-btn"
                            onClick={() =>
                                onClickCancelVersion(
                                    setIsShowPopUpCancel,
                                    isEdit,
                                    onBackEditionPanel,
                                    dataProduct
                                )
                            }
                        >
                            {trI18n('COMBTN001')}
                        </Button>
                        <Button
                            className="btn-primary btn-hg32 header-actions-btn"
                            disabled={!isSubmit}
                            onClick={async () => {
                                let dataSubmit = {
                                    API: props?.API,
                                    isSubmit,
                                    versionName,
                                    setVersionName,
                                    functionSettingValue,
                                    setFunctionSettingValue,
                                    basicSettingValue,
                                    setBasicSettingValue,
                                    advancedSettingValue,
                                    setAdvancedSettingValue,
                                    setUsedFormButtonExpand,
                                    dataProduct,
                                    userId: userDetail.id,
                                    setIsLoading,
                                    enqueueSnackbar,
                                    onBackEditionPanel,
                                    setOpenDropDownVersion,
                                    isEditVersion: dataProduct.isEditVersion,
                                    setIsOpenModalReloadPage,
                                    setIsBackToProduct,
                                    setIsBackToEdition,
                                    isDuplicateVersion: dataProduct.isDuplicateVersion,
                                    lincenseKey,
                                    setLincenseKey,
                                    affiliationOrganization: userDetail.affiliationOrganization,
                                    basicPromptAI: basicAIPrompt,
                                    defaultBasicAIPrompt,
                                    systemPrompt,
                                    chatGPTModel,
                                    knn,
                                    minScore,
                                    setDefaultSystemPrompt,
                                    setChatGPTModelDefault,
                                    setKnnDefault,
                                    setMinScoreDefault,
                                    interatorSystemPrompt,
                                    setDefaultInteratorSystemPrompt,
                                    setModelSettingList,
                                    setModelSettingAddList,
                                    modelSettingList,
                                    modelSettingAddList,
                                    isShowPopUpCancel, 
                                    setIsShowPopUpCancel,
                                    setIsReloadPage,
                                    listGptModel,
                                    kBoardSystemPrompt: kBoardSystemPromptLink
                                }
                                await handleSubmitFormVersion(dataSubmit);
                            }}
                        >
                            {trI18n('COMBTN011')}
                        </Button>
                    </div>
                </div>

                <div className="version-label border-bottom">
                    <OverFlowTooltipWithTabsMui
                        className="product-name-tooltip"
                        value={`${dataProduct.nameProduct} - ${dataProduct.editionName}`}
                    />
                </div>

                <div className="version-name-edit border-bottom">
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32"
                        variant="outlined"
                        spellCheck={false}
                        placeholder={trI18n('VERSION_NAME_PLACEHOLDER')}
                        value={versionName.value}
                        onChange={e => handleChangeVersionName(e)}
                        onBlur={e => handleOnBlur(e)}
                        helperText={tr(versionName.error)}
                        error={!Utils.isEmptyString(versionName.error)}
                    />
                </div>
            </div>

            <div className="version-body">
                {/* FunctionSetting */}
                <div
                    className={
                        usedFormButtonExpand ? 'accordionForm accordionForm--show' : 'accordionForm'
                    }
                    id="FunctionSetting"
                >
                    <label
                        className="accordionHead"
                        onClick={() => handleOpenListOptions('FunctionSetting')}
                    >
                        {trI18n('FUNCTION_SETTING')}
                    </label>
                    <div className="accordionContent">
                        <FormInput
                            type="FUNCTION_SETTING"
                            value={functionSettingValue}
                            setValue={setFunctionSettingValue}
                            setBasicSettingValue={setBasicSettingValue}
                            setAdvancedSettingValue={setAdvancedSettingValue}
                            setIsEdit={setIsEdit}
                            lincenseKey={lincenseKey}
                            setLincenseKey={setLincenseKey}
                            licenseKeyDefault={licenseKeyDefault}
                            setIsChangeLincenseKey={setIsChangeLincenseKey}
                            isRootSetting={isRootSetting}
                            basicAIPrompt={basicAIPrompt}
                            setBasicAIPrompt={setBasicAIPrompt}
                            setIsLoading={setIsLoading}
                            setIsOpenModalReloadPage={setIsOpenModalReloadPage}

                            systemPrompt={systemPrompt}
                            setSystemPrompt={setSystemPrompt}
                            API={props?.API}
                            isChangeSystemPrompt={isChangeSystemPrompt}
                            setIsChangeSystemPrompt={setIsChangeSystemPrompt}
                            defaultSystemPrompt={defaultSystemPrompt}

                            chatGPTModel={chatGPTModel}
                            setChatGPTModel={setChatGPTModel}
                            chatGPTModelList={listGptModel}
                            knn={knn}
                            setKnn={setKnn}
                            minScore={minScore}
                            setMinScore={setMinScore}
                            chatGPTModelDefault={chatGPTModelDefault}
                            knnDefault={knnDefault}
                            minScoreDefault={minScoreDefault}
                            interatorSystemPrompt={interatorSystemPrompt}
                            setInteratorSystemPrompt={setInteratorSystemPrompt}
                            isChangeInteratorSystemPrompt={isChangeInteratorSystemPrompt}
                            setIsChangeInteratorSystemPrompt={setIsChangeInteratorSystemPrompt}
                            defaultInteratorSystemPrompt={defaultInteratorSystemPrompt}
                            modelSettingList={modelSettingList}
                            setModelSettingList={setModelSettingList}
                            modelSettingAddList={modelSettingAddList}
                            setModelSettingAddList={setModelSettingAddList}
                            modelSettingListRoot={modelSettingListRoot} 
                            setModelSettingListRoot={setModelSettingListRoot}
                            kBoardSystemPromptLink={kBoardSystemPromptLink}
                            setKBoardSystemPromptLink={setKBoardSystemPromptLink}
                            kBoardPromptDetail={kBoardPromptDetail}
                            setKBoardPromptDetail={setKBoardPromptDetail}
                            errorKBoardSystemPrompt={errorKBoardSystemPrompt}
                            setErrorKBoardSystemPrompt={setErrorKBoardSystemPrompt}
                        />
                    </div>
                </div>

                {/* BasicSetting */}
                <div
                    className={
                        usedFormButtonExpand ? 'accordionForm accordionForm--show' : 'accordionForm'
                    }
                    id="BasicSetting"
                >
                    <label
                        className="accordionHead accordionHead-text"
                        onClick={() => handleOpenListOptions('BasicSetting')}
                    >
                        {trI18n('BASIC_SETTING')}
                    </label>
                    <div className="accordionContent">
                        <FormInput
                            type="BASIC_SETTING"
                            value={basicSettingValue}
                            setValue={setBasicSettingValue}
                            knowledgeService={
                                functionSettingValue.knowledgeFunction.group.knowledgeService.value
                            }
                            internalQACounterSettings={
                                functionSettingValue.internalQACounterSettings.value
                            }
                            deskService={
                                functionSettingValue.externalServiceDeskSettings.group.deskService.value
                            }
                            setIsEdit={setIsEdit}
                        />
                    </div>
                </div>

                {/* AdvanceSetting */}
                <div
                    className={
                        usedFormButtonExpand ? 'accordionForm accordionForm--show' : 'accordionForm'
                    }
                    id="AdvanceSetting"
                >
                    <label
                        className="accordionHead accordionHead-text"
                        onClick={() => handleOpenListOptions('AdvanceSetting')}
                    >
                        {trI18n('ADVANCED_SETTING')}
                    </label>
                    <div className="accordionContent">
                        <FormInput
                            type="ADVANCE_SETTING"
                            value={advancedSettingValue}
                            setValue={setAdvancedSettingValue}
                            advancedOptionSettings={
                                functionSettingValue.advancedOptionSettings.value
                            }
                            knowledgeService={
                                functionSettingValue.knowledgeFunction.group.knowledgeService.value
                            }
                            internalQACounterSettings={
                                functionSettingValue.internalQACounterSettings.value
                            }
                            deskService={
                                functionSettingValue.externalServiceDeskSettings.group.deskService.value
                            }
                            setIsEdit={setIsEdit}
                        />
                    </div>
                </div>
            </div>

            {/* dialog cancel  */}
            <ConfirmDialog
                isOpen={isShowPopUpCancel}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onYesCanCelOrClosePanel(
                        props?.API,
                        setIsClosePanelVersion,
                        isSubmit,
                        functionSettingValue,
                        setFunctionSettingValue,
                        basicSettingValue,
                        setBasicSettingValue,
                        advancedSettingValue,
                        setAdvancedSettingValue,
                        setUsedFormButtonExpand,
                        dataProduct,
                        versionName,
                        userDetail.id,
                        setIsLoading,
                        enqueueSnackbar,
                        onBackEditionPanel,
                        setIsShowPopUpCancel,
                        setOpenDropDownVersion,
                        setVersionName,
                        dataProduct.isEditVersion,
                        setIsOpenModalReloadPage,
                        setIsBackToProduct,
                        setIsBackToEdition,
                        dataProduct.isDuplicateVersion,
                        lincenseKey,
                        setLincenseKey,
                        basicAIPrompt,
                        defaultBasicAIPrompt,
                        userDetail.affiliationOrganization,

                        systemPrompt,
                        chatGPTModel,
                        knn,
                        minScore,
                        setDefaultSystemPrompt,
                        setChatGPTModelDefault,
                        setKnnDefault,
                        setMinScoreDefault,
                        interatorSystemPrompt,
                        setDefaultInteratorSystemPrompt,
                        setModelSettingList,
                        setModelSettingAddList,
                        modelSettingList,
                        modelSettingAddList,
                        isShowPopUpCancel,
                        setIsReloadPage,
                        listGptModel
                    )
                }
                closeCallBack={() =>
                    onClickNoCanCelOrClosePanel(
                        dataProduct,
                        onBackEditionPanel,
                        setIsClosePanelVersion
                    )
                }
                cancelCallBack={() => {
                    setIsShowPopUpCancel(false);
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                isShowClassnameButton={false}
            />

            {/* dialog close panel  */}
            <ConfirmDialog
                isOpen={isClosePanelVersion.isClose}
                msgConfirm={trI18n('MSG-CM-CONFIRM-EXIT-PAGE-WITHOUT-SAVING')}
                okCallBack={async () =>
                    await onYesCanCelOrClosePanel(
                        props?.API,
                        setIsClosePanelVersion,
                        isSubmit,
                        functionSettingValue,
                        setFunctionSettingValue,
                        basicSettingValue,
                        setBasicSettingValue,
                        advancedSettingValue,
                        setAdvancedSettingValue,
                        setUsedFormButtonExpand,
                        dataProduct,
                        versionName,
                        userDetail.id,
                        setIsLoading,
                        enqueueSnackbar,
                        onBackEditionPanel,
                        setIsShowPopUpCancel,
                        setOpenDropDownVersion,
                        setVersionName,
                        dataProduct.isEditVersion,
                        setIsOpenModalReloadPage,
                        setIsBackToProduct,
                        setIsBackToEdition,
                        dataProduct.isDuplicateVersion,
                        lincenseKey,
                        setLincenseKey,
                        basicAIPrompt,
                        defaultBasicAIPrompt,
                        userDetail.affiliationOrganization,

                        systemPrompt,
                        chatGPTModel,
                        knn,
                        minScore,
                        setDefaultSystemPrompt,
                        setChatGPTModelDefault,
                        setKnnDefault,
                        setMinScoreDefault,
                        interatorSystemPrompt,
                        setDefaultInteratorSystemPrompt,
                        setModelSettingList,
                        setModelSettingAddList,
                        modelSettingList,
                        modelSettingAddList,
                        isShowPopUpCancel,
                        setIsReloadPage,
                        listGptModel
                    )
                }
                closeCallBack={() => {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
                        panelId: props.panelId,
                        tabId: props.tabId
                        
                    })
                    setIsClosePanelVersion({isClose: false, componentType: ProductManagementConstant.EDITION_LIST})
                }}
                cancelCallBack={() => {
                    setIsClosePanelVersion({
                        isClose: false,
                        componentType: ProductManagementConstant.EDITION_LIST
                    });
                }}
                textSubmit={trI18n('COMBTN002')}
                textClose={trI18n('COMBTN007')}
                isShowClassnameButton={false}
            />
            <ConfirmDialog
                isOpen={isOpenModalReloadPage}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => {
                    callBackReloadPage(onBackEditionPanel, isBackToProduct, isBackToEdition, dataProduct, setOpenDropDownVersion)
                }}
            />
            <ConfirmDialog
                isOpen={isReloadPage}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </form>
    );
}

VersionList.propTypes = {
    API: PropTypes.any,
    dataProduct: PropTypes.shape({
        isDuplicateVersion: PropTypes.bool,
        isEditVersion: PropTypes.bool,
    }),
}